import React, { useEffect, useState } from "react";
import BreadCrumb from "common/breadcrumb";

import Tab from "common/components/tab/tab";
import { Nav } from "common/components/tab/nav";

import { BrandingData } from "admin-portal/settings/branding";
import { useLocation } from "react-router-dom";

import { AppDispatch } from "slices/store";
import { useAppSelector, useAppDispatch } from "slices/hook";
import { getAuthState } from "slices/auth/login/reducer";

import { Vehicle } from "models/vehicle/vehicle";

import SearchVehicleComponent from "admin-portal/vehicle/search-vehicle";
import AddEditVehicleComponent from "admin-portal/vehicle/add-vehicle";

const VehiclesPage = () => {
  const dispatch: AppDispatch = useAppDispatch();
  const { loggedInuser } = useAppSelector(getAuthState);

  // Retrieve query parameters
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const vehicleId = searchParams.get("id");
  const optParam = searchParams.get("opt");

  const [loading, setLoading] = useState(false);
  const [addedVehicle, setAddedVehicle] = useState<Vehicle>();
  const [editedVehicle, setEditedVehicle] = useState<Vehicle>();
  const [activeTab, setActiveTab] = React.useState<string>("tab-vehicles");

  // Effect to set the default tab based on the presence of vehicleId
  useEffect(() => {
    if (vehicleId || optParam == "n") {
      setActiveTab("tab-add-vehicle");
    }
  }, [vehicleId]);

  useEffect(() => {
    console.log("Active tab updated to:", activeTab);
  }, [activeTab]);

  const handleTabSelect = (eventKey: string | null) => {
    if (eventKey === "tab-add-vehicle" || eventKey === "tab-edit-vehicle") {
      // This is where you can force Component to refresh data
      // For example, you can set a state that triggers a refresh
      // setVehicle((prev) => ({ ...prev, refresh: true }));
    }
    setActiveTab(eventKey || "tab-vehicles");
  };

  const onVehicleSave = (vhcl: Vehicle) => {
    setAddedVehicle({ ...vhcl });
  };
  const onVehicleEditClick = (vhcl: Vehicle) => {
    console.log("Edit clicked for vehicle: ", vhcl);
    setEditedVehicle({ ...vhcl });
    setActiveTab("tab-add-vehicle");
  };

  const tenantId = loggedInuser?.activeTenantId;

  return (
    <React.Fragment>
      <BreadCrumb title={"Vehicles"} pageTitle={BrandingData.bussinessDomain + " Manage"} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card">
            <div className="card-body">
              <Tab.Container defaultActiveKey={activeTab} activeTabKey={activeTab} onTabChange={handleTabSelect}>
                <Nav className="flex flex-wrap w-full text-sm font-medium text-center border-b border-slate-200 dark:border-zink-500 nav-tabs">
                  <Nav.Item eventKey="tab-vehicles" className="group">
                    <a
                      /*   href={`#${RoutePath.Admin_TenantEdit}`} */
                      data-tab-toggle
                      data-target="tab-vehicles"
                      className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                    >
                      Search
                    </a>
                  </Nav.Item>

                  <Nav.Item eventKey="tab-add-vehicle" className="group">
                    <a
                      /*  href={`#${RoutePath.Admin_TenantEdit}`} */
                      data-tab-toggle
                      data-target="tab-add-vehicle"
                      className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                    >
                      {editedVehicle != null ? "Edit" : "Add"} Vehicle
                    </a>
                  </Nav.Item>
                </Nav>

                <Tab.Content className="mt-5 tab-content">
                  <Tab.Pane eventKey="tab-vehicles" id="tab-vehicles">
                    <div className="mb-0">
                      <SearchVehicleComponent
                        onVehicleEditClick={onVehicleEditClick}
                        key={activeTab} // Change key to force re-render on tab switch
                      ></SearchVehicleComponent>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="tab-add-vehicle" id="tab-add-vehicle">
                    <div className="mb-0">
                      <AddEditVehicleComponent
                        vehicle={editedVehicle}
                        onVehicleSaveSuccess={onVehicleSave}
                      ></AddEditVehicleComponent>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default VehiclesPage;
